// extracted by mini-css-extract-plugin
module.exports = {"summaryError":"KalkulatorResultat_summaryError__gbtA_","summaryText":"KalkulatorResultat_summaryText__xHfQN"};